import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, Validators } from '@angular/forms';
import { event } from 'jquery';
 
@Component({
  selector: 'app-comments-dialog',
  templateUrl: './comments-dialog.component.html',
  styleUrls: ['./comments-dialog.component.css']
})
export class CommentsDialogComponent implements OnInit {
 
  public isNotesView = false;
  comments = new UntypedFormControl('', [Validators.required])
  isApproved = false;
  constructor(@Optional() public dialogRef: MatDialogRef<CommentsDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogInfo: any) { }
 
  ngOnInit() {
    if (this.dialogInfo && this.dialogInfo.isNote) {
      this.isNotesView = true;
    }
    if (this.dialogInfo && this.dialogInfo.isApproved) {
      this.isApproved = true;
    }
  }
 
  commments(event)
  {
    this.comments=event.target
  }
  
  closeDialog(isClose) {
        if (isClose) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close(this.comments.value);
    }
  }
}
